import { BarChart } from "@mui/x-charts/BarChart";
import { ChartCard } from "../../../components/charts/ChartCard";
import { CHART_COLORS, chartSx, formatRupees, formatRupeesAxis } from "../../../components/charts/chartTheme";
import { FeeByGrade } from "../types";

export const FEE_CHART_TITLE = "Fee Collected vs Due by Grade";

// One bar per grade: collected in brand blue with dues stacked on top in a soft coral red,
// so the bar's height is the grade's total billed and red flags what is still pending.
// Validated with the blue: colour-blind ΔE 21.3, normal ΔE 32.1, both >= 3:1 on white.
const DUE_COLOR = "#e5534b";

// Also rendered on the Home page (sample data, bare inside its app-window frame), so both always look identical.
export const FeeAnalyticsBarChart = ({ data, bare }: { data: FeeByGrade[]; bare?: boolean }) => {
  return (
    <ChartCard title={FEE_CHART_TITLE} bare={bare}>
      <BarChart
        height={300}
        dataset={data}
        xAxis={[{ scaleType: "band", dataKey: "grade", disableTicks: true, categoryGapRatio: 0.5 }]}
        yAxis={[{ width: 56, disableLine: true, disableTicks: true, valueFormatter: formatRupeesAxis }]}
        series={[
          { dataKey: "collected", label: "Collected", stack: "fees", color: CHART_COLORS.series1, valueFormatter: formatRupees },
          { dataKey: "due", label: "Due", stack: "fees", color: DUE_COLOR, valueFormatter: formatRupees },
        ]}
        borderRadius={6}
        grid={{ horizontal: true }}
        margin={{ top: 10, right: 8, bottom: 0, left: 0 }}
        slotProps={{ legend: { position: { vertical: "top", horizontal: "end" } } }}
        // A thin white seam between the two segments keeps a small due slice distinct from the blue below it.
        sx={{ ...chartSx, "& .MuiBarElement-root": { stroke: "#fff", strokeWidth: 1.5 } }}
      />
    </ChartCard>
  );
};
